
import { Facebook, Instagram, Youtube, Twitter, Link } from 'lucide-react';
import { useSocialAccounts } from '@/hooks/useSocialAccounts';

const platformIcons = {
  facebook: Facebook,
  instagram: Instagram,
  youtube: Youtube,
  twitter: Twitter,
  tiktok: Link
};

const platformColors = {
  facebook: 'bg-blue-600',
  instagram: 'bg-pink-600',
  youtube: 'bg-red-600',
  twitter: 'bg-sky-500',
  tiktok: 'bg-black'
};

export const ConnectedAppsIcons = () => {
  const { accounts, loading } = useSocialAccounts();

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">Loading connected apps...</span>
      </div>
    );
  }

  if (accounts.length === 0) {
    return (
      <div className="flex items-center gap-2 text-gray-500">
        <Link size={16} />
        <span className="text-sm">No connected apps</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600 mr-2">Connected apps:</span>
      <div className="flex gap-2">
        {accounts.map((account) => {
          const IconComponent = platformIcons[account.platform as keyof typeof platformIcons];
          const colorClass = platformColors[account.platform as keyof typeof platformColors];
          
          if (!IconComponent) return null;
          
          return (
            <div
              key={account.id}
              className={`w-8 h-8 ${colorClass} rounded-full flex items-center justify-center`}
              title={`Connected to ${account.platform}`}
            >
              <IconComponent size={14} className="text-white" />
            </div>
          );
        })}
      </div>
    </div>
  );
};
